namespace Portico.Models {
	// Tenant IDs
	export const TENANT_TC = 10001;

	// GUID
	export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';
	// Setup GUIDs
	export const DATA_GROUP_LNF_SHADOW = '195366AC-2229-4EA8-97AE-792DE036152E';
	export const DATA_GROUP_LNF_SQUARE = '5E461156-35E0-4F1D-9C43-0C47AFA2101B';
	export const DATA_GROUP_STANDARD_DEFAULT = '1E02AE1F-13DC-49F8-9EBB-81D6023BFD6A';
	export const DATA_GROUP_TYPE_PORTAL = 'B006FE97-8D91-4A13-A41D-A550624D65C3';
	export const DATA_GROUP_TYPE_TEMPLATE = '1E51AC95-7F43-4D75-B9D6-295D0B881044';
    export const PORTAL_GROUP_DEMO = '2A92F150-E981-4E34-82A1-2A92B2B10BAD';

    export const KnownKeyNames = {
        loggingLevel: 'logging-level',
        tenant: 'tenant',
        legacyProgramSecureId: 'legacy-program-secure-id',
        secureId: 'secure-id',
        surveyId: 'survey-id',
        survey: 'survey',
        programType: 'program-type',
        templateId: 'template-id'
    }

    // Session Storage Keys
    export const JWT_STORAGE_KEY = 'gateway-jwt';
    export const SESSION_STORAGE_KEY = 'session';
    export const IS_CHILD_KEY = 'is-child';

	// Session Status
    export const SESSION_ACTIVE = 'active';
    export const SESSION_EXPIRED = 'expired';
    export const SESSION_EXPIRING = 'expiring';
}
